<template>
    <div 
        class="social"
        :class="{
            'large': size === 'lg',
            'small': size === 'sm',
            'bordered': type === 'bordered'
        }"
    >
        <Icon :icon="icon"/>
        <p v-if="followers" class="social__text">{{followers}} Followers</p>
        <p v-if="subscribers" class="social__text">{{subscribers}} Subscribers</p>
    </div>
</template>

<script>
import Icon from '@/components/Theme/Icon'
export default {
    name: 'Social',
    components: {
        Icon
    },
    props: {
        icon: String,
        followers: [Number,String],
        subscribers: [Number, String],
        type: String,
        size: {
            type: String,
            default: 'lg'
        },
    }
}
</script>

<style lang="scss" scoped>
$large: 24px;
$small: 20px;
$large_margin: 12px;
$small_margin: 8px;
$color: #333333;
$font_size: 14px;
$line_height: 20px;
$border: 1px solid #CBD5E0;
.social {
    display: flex;
    align-items: center;
    padding-right: $large_margin;
    &__text {
        margin-bottom: 0;
        font-size: $font_size;
        margin-left: $small_margin;
        line-height: 21px;
    }
    &.bordered:not(:last-child) {
        border-right: $border;
        margin-right: $large_margin;
    }
    &.large {
        img {
            width: $large;
        }
        p {
            font-weight: bold;
        }
    }
    &.small {
        img {
            width: $small;
        }
    }
}
</style>>
